import React, { useEffect, useState, useRef, useCallback } from "react"


import { ReactComponent as ArrowPrevIcon } from "../../assets/svg/arrow-previous.svg";
import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";
import { ReactComponent as ScanIcon } from "../../assets/svg/scan.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as SlotFilterIcon } from "../../assets/svg/filter-search.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as FilterCloseIcon } from "../../assets/svg/close-filter.svg";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-outline.svg";
import { ReactComponent as SearchIcon } from "../../assets/svg/search.svg";
import { ReactComponent as EditIcon } from "../../assets/svg/edit-icon.svg";
import { ReactComponent as OfficeIcon } from "../../assets/svg/office-icon.svg";
import { ReactComponent as MoreIcon } from "../../assets/svg/more-icon.svg";
import { ReactComponent as MailIcon } from "../../assets/svg/mail-icon.svg";
import { ReactComponent as PhoneIcon } from "../../assets/svg/phone-grey.svg";
import { ReactComponent as ProfileIcon } from "../../assets/svg/profile-icon.svg";
import { ReactComponent as ImageRemoveIcon } from "../../assets/svg/delete-img.svg";

import RoomImage from "../../assets/png/room-image.png";
import SearchWithAPI from "../searchbox/searchbox";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { format, parse } from 'date-fns';
import { apiCallAdmin } from "../../services/api-service";
import { useNavigate } from "react-router-dom";
import { Form, Button, InputGroup, Toast, ToastContainer } from "react-bootstrap";
import Header from "../common/Header";
import './material-style.css';
import './room-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'flatpickr/dist/flatpickr.min.css';
import flatpickr from 'flatpickr';
import LoaderModal from "../common/Loader.js";
import { ReactComponent as NoRecordsFound } from "../../assets/svg/no-records-found.svg";
import { useGlobal } from "../../GlobalContext.js";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import ReactPaginate from "react-paginate";
export default function UserList() {
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const { selectedMenu, setSelectedMenu } = useGlobal();
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;


  const navigate = useNavigate();


  const scrollRefs = useRef([]);
  const alertRef = useRef(null);
  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const scrollLeft = (index) => {
    const ref = scrollRefs.current[index];
    if (ref) {
      ref.scrollBy({ left: -100, behavior: "smooth" });
    }
  };
  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * itemsPerPage;
      setItemOffset(newOffset); // Not event.selected
    },
    [itemsPerPage]
  );
  const scrollRight = (index) => {
    const ref = scrollRefs.current[index];
    if (ref) {
      ref.scrollBy({ left: 100, behavior: "smooth" });
    }
  };
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertIndex(null); // Close the alert
    }
  };

  const [selectedTap, setTapValue] = useState('upcoming');

  const [floorSearchUrl, setFloorSearchUrl] = useState('');



  const [errorMessage, setErrorMessage] = useState({ first_name: '', email: '', employee_id: '', password: '', confirm_password: '', role_id: '' });
  const [userId, setUserId] = useState("");
  const [codeInputValue, setCodeInputValue] = useState("");
  const [nameInputValue, setNameInputValue] = useState("");
  const [emailInputValue, setEmailInputValue] = useState("");
  const [selectedOffice, setOfficeValue] = useState('');
  const [selectedOfficeLabel, setOfficeLabel] = useState('');
  const [selectedFloor, setFloorValue] = useState('');
  const [selectedRoleLabel, setRoleLabel] = useState('');
  const [roleInputValue, setRoleInputValue] = useState("");
  const [mobileNumberInputValue, setMobileNumberInputValue] = useState(0);
  const [passwordInputValue, setPasswordInputValue] = useState("");
  const [confirmPasswordInputValue, setConfirmPasswordInputValue] = useState("");
  const [employeeIDInputValue, setEmployeeIDInputValue] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [selectedTimezoneLabel, setTimezoneLabel] = useState('');
  const [timezoneInputValue, setTimezoneInputValue] = useState("");
  const [selectedRoleOption, setSelectedRoleOption] = useState(null);
  const [selectedTimeZoneOption, setSelectedTimeZoneOption] = useState(null);

  const [availableFeatureValue, setAvailableFeatureValue] = useState("");
  const [availableFeatureList, setAvailableFeatureList] = useState([]);
  const [officeDetail, setOfficeDetail] = useState({});
  const [showPicker, setShowPicker] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [base64File, setBase64File] = useState(null);

  const [orgImage, setOrgImg] = useState('');
  const [selectedCategory, setCategoryValue] = useState('');
  const [selectedSlot, setSlotValue] = useState('30 mins');
  const [selectedBookId, setBookId] = useState([]);
  const [bookIdList, setBookIdList] = useState([]);
  const [categoryList, setCategory] = useState([]);

  const [floorList, setFloors] = useState([]);
  const [roomList, setRooms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const [rolePermissionList, setRolePermissionList] = useState([]);
  const [userType, setUserType] = useState('');
  const [timeZoneList, setTimeZoneList] = useState([]);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const openModal = (id, index) => {
    setRoomIndex(index);
    setUserId(id);
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    setErrorMessage({ first_name: '', email: '', employee_id: '', password: '', confirm_password: '', role_id: '', timezone_id: '' });
    setUserId(null)
    setSelectedImage(null);
    setUserId('')
    setNameInputValue('');
    setRoleLabel('')
    setRoleInputValue('');
    setEmployeeIDInputValue('');
    setEmailInputValue('');
    setMobileNumberInputValue('');
    setTimezoneInputValue('');
    setTimezoneLabel('');
    setSelectedTimeZoneOption(null);
    setSelectedRoleOption(null);
  }

  const [selectedRoomIndex, setRoomIndex] = useState(-1);
  const [upcomingCount, setUpcomingCount] = useState(0);
  const [pastCount, setPastCount] = useState(0);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [alertIndex, setAlertIndex] = useState(null);
  const [time, setTime] = useState("");

  const handleChange = (event) => {
    setTime(event.target.value);
  };
  const menuBoxInactive = { width: '128px', height: '44px', display: 'flex', justifyContent: "center", alignItems: "center", };
  const menuBoxActive = { width: '128px', height: '44px', display: 'flex', justifyContent: "center", alignItems: "center", borderBottom: "3px solid #842234", };
  const menuColorActive = { fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: '#842234', };
  const menuColorInactive = { fontSize: "15px", fontWeight: "400", lineHeight: "17.17px", color: '#1E1E1E', };
  const profileName = { fontSize: "14px", fontWeight: "700", color: '#842234', };
  const title = { fontSize: "24px", fontWeight: "800", color: '#1E1E1E', };
  const subtitle = { fontSize: "15px", fontWeight: "400", color: '#81878C', };
  const roomTitle = { fontSize: "15px", fontWeight: "700", color: '#1E1E1E', };
  const seatCount = { fontSize: "13.5px", fontWeight: "400", color: '#81878C', marginTop: '8px', };
  const availableTitle = { fontSize: "12px", fontWeight: "400", color: '#81878C', marginBottom: '8px', };
  const availableName = { fontSize: "12.5px", fontWeight: "400", color: '#21272C' };
  const slotTitle = { fontSize: "13px", fontWeight: "700", color: '#1E1E1E' };
  const slotTitleSelected = { fontSize: "12px", fontWeight: "500", color: '#842234' };
  const filterTitle = { fontSize: "24px", fontWeight: "700", color: '#1E1E1E' };
  const officeTitle = { marginTop: '16px', marginBottom: '8px', fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: '#1E1E1E', };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "677px",
      height: "500px",
      textAlign: "center",
      overflowY: "auto"
    },
  };

  const getTimezoneOffset = () => {
    const offset = new Date().getTimezoneOffset(); // Offset in minutes
    const sign = offset > 0 ? "-" : "+"; // Determine the sign
    const absoluteOffset = Math.abs(offset);
    const hours = String(Math.floor(absoluteOffset / 60)).padStart(2, "0");
    const minutes = String(absoluteOffset % 60).padStart(2, "0");

    return `${sign}${hours}:${minutes}`;
  };
  const handleCategoryClick = (category) => {
    setCategoryValue(category);

  };


  useEffect(() => {
    flatpickr('#flatpickr-time', {
      enableTime: true,
      noCalendar: true,
      dateFormat: 'H:i',
    });
  }, []);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    setSelectedMenu("Users");
    getTimeZoneList();
    fetchOptions('');
    getRolePermission();

  }, []);
  const getRolePermission = async () => {

    try {
      const response = await apiCallAdmin("get", "get_role_permission/27");
      if (response?.status === 200 && response.data.success === true) {
        setUserType(response.data.user_type);
        setRolePermissionList(response.data.role_permission ?? []);
      } else {
        setRolePermissionList([]);
      }

      // const data = await response.json();

    } catch (err) {
      console.error("Error fetching floors:", err);

    } finally {

    }
  };
  useEffect(() => {
    console.log('errorMessage.....', errorMessage);

  }, [errorMessage]);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    console.log("Searching for:", term);
    fetchOptions(term);
  }, 1000);
  const getTimeZoneList = async () => {




    try {
      const response = await apiCallAdmin("get", "get_timezone");

      // const data = await response.json();
      if (response?.data?.success === true) {

        if (response.data.suggestionlist.length > 0) {

          const index = response.data.suggestionlist.findIndex((element) =>
            element['timezone'] === getTimezoneOffset());
          if (index > -1) {
            setTimezoneLabel(response.data.suggestionlist[index]["label"]);
            setTimezoneInputValue(response.data.suggestionlist[index]["value"]);
            setSelectedTimeZoneOption({ 'label': response.data.suggestionlist[index]["label"], 'value': response.data.suggestionlist[index]["value"] })
          }




        } else {
          setRooms([]);
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {

    }
  };
  useEffect(() => {
    fetchOptions("");
  }, [itemOffset, itemsPerPage]);
  const fetchOptions = async (term) => {
    setLoading(true);
    setError(null);


    try {
      const response = await apiCallAdmin("get", "user", null, {
        params: { search: term, skip: itemOffset, limit: itemsPerPage },
      });

      // const data = await response.json();
      if (response?.data?.success === true) {

        if (response.data.users.length > 0) {

          setRooms(response.data.users);
          setTotalCount(response.data.total_rec ?? 0);
          setPageCount(response.data.total_pgs);
          console.log("Room List:", roomList);
          console.log("Room List Length:", roomList.length);


        } else {
          setRooms([]);
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const editOffice = async (id) => {
    setLoading(true);
    setError(null);


    try {
      const response = await apiCallAdmin("get", `user/${id}`);

      // const data = await response.json();
      if (response?.data?.success === true) {
        setIsOpen(true);
        if (response.data.user) {
          setSelectedImage(response.data.user.profile_image != null && response.data.user.profile_image !== "" ? response.data.user.profile_image : null);
          setUserId(response.data.user.id ?? 0)
          setNameInputValue(response.data.user.first_name ?? '');
          setRoleLabel(response.data.user.role ?? '')
          setRoleInputValue(response.data.user.role_id ?? 0);
          setEmployeeIDInputValue(response.data.user.employee_id ?? '');
          setEmailInputValue(response.data.user.email ?? '');
          setMobileNumberInputValue(response.data.user.contact_number ?? '');
          setTimezoneInputValue(response.data.user.timezone_id ?? 0);
          setTimezoneLabel(response.data.user.timezone ?? '')

        } else {

        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const submitOffice = async () => {


    const data = {

      "employee_id": employeeIDInputValue,
      "role_id": roleInputValue,
      "first_name": nameInputValue,
      "last_name": "",
      "email": emailInputValue.trim(),
      "contact_number": mobileNumberInputValue,
      "location_id": "",
      "reporting_person_id": "",
      "city_id": "",
      "state_id": "",
      "country_id": "",
      "timezone_id": timezoneInputValue,
      "address": "",
      "multi_factor_auth": "",
      "profile_image": base64File,
      "password": passwordInputValue,
      "confirm_password": confirmPasswordInputValue,
      "image_removed": true
    };

    const response = await apiCallAdmin("post", "user", data);
    if (response?.status === 200 && response.data?.success === true) {
      closeModal()
      fetchOptions('');
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow()
    } else if (response?.status === 400) {
      setErrorValue(response.data.error);
    }



  };

  const updateOffice = async () => {

    console.log("get_slots api called");
    const data = {

      "employee_id": employeeIDInputValue,
      "role_id": roleInputValue,
      "first_name": nameInputValue,
      "last_name": "",
      "email": emailInputValue.trim(),
      "contact_number": mobileNumberInputValue,
      "location_id": "",
      "reporting_person_id": "",
      "city_id": "",
      "state_id": "",
      "country_id": "",
      "timezone_id": timezoneInputValue,
      "address": "",
      "multi_factor_auth": "",
      "profile_image": base64File,
      "password": passwordInputValue,
      "confirm_password": confirmPasswordInputValue,
      "image_removed": true

    };

    const response = await apiCallAdmin("put", `user/${userId}`, data);
    if (response?.status === 200 && response.data?.success === true) {
      closeModal();
      fetchOptions('');
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow()
    } else if (response?.status === 400) {
      setErrorValue(response.data.error);
    }
  };

  const deleteOffice = async (id) => {

    console.log("get_slots api called");


    const response = await apiCallAdmin("delete", `user/delete/${id}`);
    if (response?.status === 200 && response.data?.success === true) {
      setAlertIndex(null);
      fetchOptions('');
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow()
    }
  };

  const setErrorValue = async (errorMsg) => {
    setErrorMessage({
      first_name: errorMsg['first_name'] !== undefined ? errorMsg['first_name'][0] : '',
      email: errorMsg['email'] !== undefined ? errorMsg['email'][0] : '',
      employee_id: errorMsg['employee_id'] !== undefined ? errorMsg['employee_id'][0] : '',
      password: errorMsg['password'] !== undefined ? errorMsg['password'][0] : '',
      confirm_password: errorMsg['confirm_password'] !== undefined ? errorMsg['confirm_password'][0] : '',
      role_id: errorMsg['role_id'] !== undefined ? errorMsg['role_id'][0] : '',
      timezone_id: errorMsg['timezone_id'] !== undefined ? errorMsg['timezone_id'][0] : '',
    });
    setError(null);
  }
  const handleRoleDropdownChange = (option) => {
    console.log(option)
    setSelectedRoleOption(option)
    setRoleInputValue(option.value);
    setRoleLabel('');
  };
  const handleTimezoneDropdownChange = (option) => {
    console.log(option)
    setSelectedTimeZoneOption(option)
    setTimezoneInputValue(option.value);
    setTimezoneLabel('');
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result; // this will be the byte code (base64String)
        console.log("Base64 String:", base64String.toString());
        setBase64File(base64String);
        console.log(base64String); // You can view the byte code in the console
      };
      reader.readAsDataURL(file);

      setSelectedImage(URL.createObjectURL(file));
    } else {
      alert("Please select a valid image file.");
    }
  };
  const handleFeatureAdd = () => {
    if (availableFeatureValue !== '') {
      const index = availableFeatureList
        .findIndex(element => element === availableFeatureValue);
      if (index === -1) {
        setAvailableFeatureList((prevAvailable) => {
          prevAvailable.push(availableFeatureValue);
          setAvailableFeatureValue('');
          return prevAvailable;
        });
      }
    }
  }
  function checkPermission(menuName, permission) {
    return (rolePermissionList
      .findIndex((element) =>
        element['name'] === menuName &&
        element['menu_permission'] === true &&
        element[permission] === true) > -1) ? true : false;
  }

  return (
    <Container fluid className="GTWalsheimTrial px-0">
      {/*  <Header selectedTab={'Users'}/> */}


      {(userType === "A" || userType === "SA") && (
        <Row className="flex-wrap px-3" style={{ height: 'calc(100vh - 68px)', overflow: 'auto', scrollbarWidth: "none", msOverflowStyle: "none", justifyContent: 'center', }}>

          <Col sm={12} xl={8} style={{ padding: '16px', justifyContent: 'center', }}>

            <div style={title} >
              Your all users are listed here!
            </div>



            &nbsp;&nbsp;
            <Form >
              <Row xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', }}>
                <Col xs={8} xl={9} >
                  <Form.Group style={{ borderRadius: "100px", border: '0.6px solid #E5E5E5', overflow: 'hidden' }}>

                    <InputGroup >

                      <Button variant="outline-secondary" style={{ backgroundColor: '#ffffff', border: 'none', outline: 'none', boxShadow: 'none' }}>
                        <SearchIcon />
                      </Button>
                      <Form.Control

                        className="custom-input"
                        type="text"
                        placeholder="Search..."
                        value={searchInputValue}
                        onChange={(event) => {
                          setSearchInputValue(event.target.value);

                          handleSearch(event.target.value);
                        }}
                        style={{ border: 'none', outline: 'none', boxShadow: 'none' }}
                      />

                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={4} xl={2}>
                  {(<div onClick={(e) => {
                    setIsOpen(true);

                  }} style={{ cursor: "pointer", height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '100px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#842234' }}>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: '#F3F6F9' }}>Add user</div>
                  </div>)}
                </Col>
              </Row>
            </Form>
            {roomList.map((item, roomIndex) => (
              <Row key={`${roomIndex}-room`} style={{ marginTop: '16px', paddingTop: '16px', paddingBottom: '16px', paddingRight: '16px', background: '#ffffff', borderRadius: '24px', display: 'flex', justifyContent: "space-between", alignItems: "center", }}>
                {/* <Row md={12} className="justify-content-between"> */}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Col style={{ display: 'flex', }}>

                    <img src={item['image'] != null && item['image'] !== '' ? item['image'] : RoomImage} alt="room" style={{ width: '48px', height: '48px', borderRadius: '100px' }} />&nbsp;&nbsp;
                    <div>
                      <div style={roomTitle} >
                        {item["name"]}
                      </div>



                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', }}>
                        <div style={{ fontSize: "13px", fontWeight: "500", color: '#842234' }} >
                          {item['employee_id'] ?? ''}
                        </div> &nbsp;&nbsp; <div style={{ width: '3px', height: '3px', backgroundColor: '#D9D9D9' }}></div>&nbsp;&nbsp;
                        <div style={{ padding: '2px 12px', fontSize: "13px", fontWeight: "400", color: '#842234', background: '#FFE9ED', borderRadius: '100px' }} >
                          {item['role_code'] ?? ''}
                        </div>
                      </div>




                    </div>

                  </Col>

                  <div key={`${roomIndex}-more`} style={{ position: "relative" }}>
                    <MoreIcon style={{ cursor: "pointer", }} onClick={() => { setAlertIndex(roomIndex === alertIndex ? null : roomIndex); }} />
                    {alertIndex === roomIndex && (
                      <div ref={alertRef} style={{
                        position: "absolute",
                        top: "40px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#ffffff",
                        color: "#1E1E1E",
                        padding: "16px",
                        borderRadius: "16px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        zIndex: 1, alignItems: 'end',
                      }}>
                        <div onClick={() => { editOffice(item['id']) }} style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }} >
                          Edit
                        </div>
                        <div onClick={() => { deleteOffice(item['id']) }} style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }} >
                          Delete
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <Col style={{ marginTop: '16px', marginLeft: '16px', marginRight: '16px', padding: '8px 12px', background: '#F9F9F9', borderRadius: '24px', }}>
                  <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                    <MailIcon />&nbsp;&nbsp;<label>{item["email"]}</label>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                    <PhoneIcon style={{ color: '#1E1E1E' }} />&nbsp;&nbsp;<label>{item["contact_number"]}</label>
                  </div>
                </Col>
              </Row >
            ))}
            {roomList.length === 0 && (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <NoRecordsFound />
              <div style={{ marginTop: '8px', fontSize: "16px", fontWeight: "500", color: '#212129', }}>No records found</div>
              <div style={{ fontSize: "13px", fontWeight: "400", color: '#8790A1', }}>Looks like you haven’t any data to show</div>
            </div>)}
            {roomList.length > 0 && (<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ fontFamily: "GT Walsheim Trial Bd", fontSize: "12px", fontWeight: "500", color: "#172b4d" }}>Records per page :</div>
                <select
                  className="select3"
                  id="perpage"
                  value={itemsPerPage}
                  onChange={(event) => {
                    setItemsPerPage(event.target.value);
                  }}
                  style={{ cursor: "pointer", fontFamily: "GT Walsheim Trial Rg", fontSize: "12px", fontWeight: "700", lineHeight: "18.9px", color: "#172b4d", borderRadius: "6px", border: "0.6px solid #E5E5E5", padding: "8px 7px", backgroundColor: "#FFFFFF" }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>

              <div style={{ marginTop: '12px' }}>
                <ReactPaginate previousLabel={<img src={lar} style={{ width: "12px", height: "12px" }} alt="previous" />} nextLabel={<img src={rar} style={{ width: "12px", height: "12px" }} alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
              </div>
            </div>)}
          </Col>

        </Row>)}
      {isOpen && (
        <div style={modalStyle.overlay}>
          <div style={modalStyle.modal}>
            <div style={{ color: '#ffffff' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', }}>
                  <div style={{ paddingLeft: '4px', fontSize: "20px", fontWeight: "700", color: '#1E1E1E' }}>{userId !== null && userId !== "" ? "Edit user" : "User details"}</div>
                </div>
                <SlotCloseIcon style={{ cursor: "pointer", }} onClick={closeModal} />
              </div>
              <div style={{ textAlign: 'start', paddingLeft: '4px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E' }} className="custom-radio">
                {userId !== null && userId !== "" ? "Now you can edit below details" : "Enter below details to create new user"}
              </div>
              <div style={{ marginTop: '20px', }}>
                <div style={{ width: '100%', display: 'flex', justifyContent: "center", alignItems: "center" }}>
                  <div style={{ width: '120px', height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '100px', background: '#FEF0F2' }}>
                    {selectedImage === null && (<div>
                      <ProfileIcon />
                      <div>
                        <label onClick={handleFileClick} style={{ cursor: "pointer", display: "inline-block", fontSize: "12px", fontWeight: "500", color: "#1E1E1E", cursor: "pointer" }}>
                          Add profile pic
                        </label>

                      </div>

                    </div>)}
                    {selectedImage !== null && (
                      <div style={{ position: "relative", }}>
                        <img src={selectedImage} alt="Selected" style={{ width: '120px', height: '120px', objectFit: "cover", borderRadius: '100px', }} />
                        {/*  'cover', 'contain', or 'fill' */}
                        <div
                          style={{
                            position: "absolute",
                            bottom: "1px",
                            left: "25%",
                          }}
                        >
                          <div style={{ display: 'flex', justifyContent: "start", alignItems: "center", }}>
                            <div onClick={() => { setSelectedFile(null); setSelectedImage(null); }} style={{ cursor: "pointer", fontSize: "11px", fontWeight: "500", width: '72px', height: '24px', borderRadius: '100px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF', color: '#FF4444' }}>
                              Remove
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <input ref={fileInputRef}
                      type="file" accept=".jpg, .jpeg, .png"
                      onChange={handleFileChange}
                      style={{ display: "none" }} // Hide the actual file input
                    />
                  </div>
                </div>
                {/* {userId!==null && userId!=="" && (<div className="material-form-group">
                          <input
                            type="text"
                            id="material-input"
                            className="form-control material-input"
                            placeholder=" " readOnly="true"
                            value={codeInputValue}
            onChange={(event) => {
              setCodeInputValue(event.target.value); // Update state with input value
            }}
                          />
                          <label htmlFor="material-input" className="material-label">
                          Code
                          </label>
                        </div>)} */}
                <div className="material-form-group">
                  <input
                    type="text"
                    id="material-input"
                    className="form-control material-input"
                    placeholder=" "
                    value={emailInputValue}
                    onChange={(event) => {
                      setEmailInputValue(event.target.value); // Update state with input value
                    }}
                  />
                  <label htmlFor="material-input" className="material-label">
                    Email
                  </label>
                </div>
                <Form.Text style={{ textAlign: 'start', }} className="text-muted" >
                  {errorMessage.email !== "" && (<div style={{ color: '#ff0000' }}>{errorMessage.email}</div>)}
                </Form.Text>
                <div className="material-form-group">
                  <input
                    type="text"
                    id="material-input"
                    className="form-control material-input"
                    placeholder=" "
                    value={nameInputValue}
                    onChange={(event) => {
                      setNameInputValue(event.target.value); // Update state with input value
                    }}
                  />
                  <label htmlFor="material-input" className="material-label">
                    User name
                  </label>
                </div>
                <Form.Text style={{ textAlign: 'start', }} className="text-muted" >
                  {errorMessage.first_name !== "" && (<div style={{ color: '#ff0000' }}>{errorMessage.first_name}</div>)}
                </Form.Text>


                <Row style={{ marginTop: '16px', display: 'flex', justifyContent: "start", alignItems: "center", }} >
                  <Col>

                    <div className="material-form-group">
                      <input
                        type="number"
                        id="material-input"
                        className="form-control material-input"
                        placeholder=" "
                        value={mobileNumberInputValue}
                        onChange={(event) => {
                          setMobileNumberInputValue(event.target.value); // Update state with input value
                        }}
                      />
                      <label htmlFor="material-input" className="material-label">
                        Mobile number
                      </label>
                    </div>

                  </Col>
                  <Col style={{ marginTop: '0.8rem', marginBottom: '0.2rem' }}>
                    <SearchWithAPI onDropdownChange={handleRoleDropdownChange} apiUrl={adminApiUrl + `get_role?application_id=27`} placeholder={"Select role"} selectedValue={selectedRoleLabel} selectedOption={selectedRoleOption} />
                    <Form.Text style={{ textAlign: 'start', }} className="text-muted" >
                      {errorMessage.role_id !== "" && (<div style={{ color: '#ff0000' }}>{errorMessage.role_id}</div>)}
                    </Form.Text>
                  </Col>
                </Row>
                <Row style={{ marginTop: '8px' }}>
                  <Col>
                    <div className="material-form-group">
                      <input
                        type="text"
                        id="material-input"
                        className="form-control material-input"
                        placeholder=" "
                        value={employeeIDInputValue}
                        onChange={(event) => {
                          setEmployeeIDInputValue(event.target.value); // Update state with input value
                        }}
                      />
                      <label htmlFor="material-input" className="material-label">
                        Employee ID
                      </label>
                    </div>
                    <Form.Text style={{ textAlign: 'start', }} className="text-muted" >
                      {errorMessage.employee_id !== "" && (<div style={{ color: '#ff0000' }}>{errorMessage.employee_id}</div>)}
                    </Form.Text>
                  </Col>
                  <Col style={{ marginTop: '0.8rem', marginBottom: '0.2rem' }}>
                    <SearchWithAPI onDropdownChange={handleTimezoneDropdownChange} apiUrl={adminApiUrl + `get_timezone`} placeholder={"Select timezone"} selectedValue={selectedTimezoneLabel} selectedOption={selectedTimeZoneOption} />
                    <Form.Text style={{ textAlign: 'start', }} className="text-muted" >
                      {errorMessage.timezone_id !== "" && (<div style={{ color: '#ff0000' }}>{errorMessage.timezone_id}</div>)}
                    </Form.Text>
                  </Col>
                </Row>
                {(userId == null || userId === "") && (<Row style={{ marginTop: '8px' }}>
                  <Col>
                    <div style={{ position: "relative", }}>
                      <div className="material-form-group">
                        <input
                          type={passwordVisible ? "text" : "password"}
                          id="material-input"
                          className="form-control material-input"
                          placeholder=" "
                          value={passwordInputValue}
                          onChange={(event) => {
                            setPasswordInputValue(event.target.value); // Update state with input value
                          }}
                        />
                        <label htmlFor="material-input" className="material-label">
                          Password
                        </label>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          transform: "translate(-50%, -50%)",
                          top: "50%",
                          right: "8px",
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: "start", alignItems: "center", }}>
                          <div onClick={() => { setPasswordVisible(!passwordVisible); }} style={{ cursor: "pointer", fontSize: "14px", fontWeight: "500", color: '#842234' }}>
                            {passwordVisible ? 'Hide' : 'View'}
                          </div>
                        </div>
                      </div>
                    </div>
                    <Form.Text style={{ textAlign: 'start', }} className="text-muted" >
                      {errorMessage.password !== "" && (<div style={{ color: '#ff0000' }}>{errorMessage.password}</div>)}
                    </Form.Text>
                  </Col>
                  <Col>
                    <div style={{ position: "relative", }}>
                      <div className="material-form-group">
                        <input
                          type="password"
                          id="material-input"
                          className="form-control material-input"
                          placeholder=" "
                          value={confirmPasswordInputValue}
                          onChange={(event) => {
                            setConfirmPasswordInputValue(event.target.value); // Update state with input value
                          }}
                        />
                        <label htmlFor="material-input" className="material-label">
                          Confirm Password
                        </label>
                      </div>

                    </div>
                    <Form.Text style={{ textAlign: 'start', }} className="text-muted" >
                      {errorMessage.confirm_password !== "" && (<div style={{ color: '#ff0000' }}>{errorMessage.confirm_password}</div>)}
                    </Form.Text>
                  </Col>
                </Row>)}












                <Row style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop: '8px' }}>
                  <div onClick={(e) => {
                    closeModal()

                  }} style={{ cursor: "pointer", width: '176px', height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '100px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF', border: '0.6px solid #E5E5E5', }}>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: '#1E1E1E' }}>Cancel</div>
                  </div>
                  <div onClick={(e) => {
                    if (userId == null || userId === 0 || userId === '') {
                      submitOffice()
                    } else {
                      updateOffice()
                    }

                  }} style={{ cursor: "pointer", width: '176px', height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '100px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#842234', }}>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: '#FFFFFF' }}>Save</div>
                  </div>
                </Row>


              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? 'success' : 'danger'} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: '#ffffff' }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <LoaderModal show={loading} />
    </Container>)



}